import * as homepageVideoActions from '../../action_creators/homepage/homepage_video_action_creators';
import HomepageVideoModel from '../../../models/homepage/homepage_video_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageVideoActions.homepageVideoLoading({}, store));
    return HomepageVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(homepageVideoActions.homepageVideoLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(homepageVideoActions.homepageVideoLoadError(err, store));
        log.error(
          err,
          `Error in homepage video actions, message: ${err.message}`
        );
      });
  };
}
